<form
  [formGroup]="form"
  [ngClass]="{ 'was-validated': isFormSubmitted }"
>
  <div class="d-flex flex-column gap-4">
    <div class="d-flex align-items-center gap-5">
      <div class="d-flex flex-column fb-40 gap-1">
        <p class="fw-medium m-0">
          {{ 'administration.companySettings.assignmentsLocationOnly.title' | translate }}
        </p>
        <p class="font-size-xs m-0">
          {{ 'administration.companySettings.assignmentsLocationOnly.description' | translate }}
        </p>
      </div>
      <base-switch formControlName="assignmentsLocationOnly"></base-switch>
    </div>

    <div class="d-flex align-items-center gap-5">
      <div class="d-flex flex-column fb-40 gap-1">
        <p class="fw-medium m-0">
          {{ 'administration.companySettings.equalPayLocationOnly.title' | translate }}
        </p>
        <p class="font-size-xs m-0">
          {{ 'administration.companySettings.equalPayLocationOnly.description' | translate }}
        </p>
      </div>
      <base-switch formControlName="equalPayLocationOnly"></base-switch>
      <div
        *ngIf="areEPAndMLPVisible"
        class="d-flex align-items-center gap-5 ms-5"
      >
        <div class="d-flex flex-column">
          <p class="font-size-xs m-0">{{ 'ep' | translate }}</p>
          <p class="font-size-xs m-0">{{ 'dateTime.inMonths' | translate }}</p>
        </div>
        <base-input
          formControlName="equalPay"
          placeholder=""
          type="number"
          [min]="1"
          class="editable-input surcharge-number-field"
          [isPreview]="!isEPAndMLPEditMode"
          [isInvalid]="!!form.get('equalPay')?.errors"
          [errorMessage]="form.get('equalPay')?.errors | baseFieldValidation"
        ></base-input>
        <div class="d-flex flex-column">
          <p class="font-size-xs m-0">{{ 'mlp' | translate }}</p>
          <p class="font-size-xs m-0">{{ 'dateTime.inMonths' | translate }}</p>
        </div>
        <base-input
          formControlName="maximumLeasePeriodDifference"
          placeholder=""
          type="number"
          [min]="1"
          [isPreview]="!isEPAndMLPEditMode"
          class="editable-input surcharge-number-field"
          [isInvalid]="!!form.get('maximumLeasePeriodDifference')?.errors"
          [errorMessage]="form.get('maximumLeasePeriodDifference')?.errors | baseFieldValidation"
        ></base-input>
        <base-button
          *ngIf="!isEPAndMLPEditMode; else saveCancelButtons"
          color="dark"
          icon="fa-solid fa-pencil"
          [size]="buttonSizes.sm"
          [iconSize]="buttonSizes.sm"
          (btnClick)="editEPAndMLP()"
        >
        </base-button>
        <ng-template #saveCancelButtons>
          <div class="d-flex align-items-center gap-2">
            <base-button
              color="dark"
              icon="fa-solid fa-check"
              [size]="buttonSizes.sm"
              [iconSize]="buttonSizes.sm"
              (btnClick)="submitEPAndMLPUpdate()"
            >
            </base-button>
            <base-button
              color="dark"
              icon="fa-solid fa-xmark"
              [size]="buttonSizes.sm"
              [iconSize]="buttonSizes.sm"
              (btnClick)="cancelEPAndMLPUpdate()"
            >
            </base-button>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="d-flex align-items-center gap-5">
      <div class="d-flex flex-column fb-40 gap-1">
        <p class="fw-medium m-0">
          {{ 'administration.companySettings.ratingsLocationOnly.title' | translate }}
        </p>
        <p class="font-size-xs m-0">
          {{ 'administration.companySettings.ratingsLocationOnly.description' | translate }}
        </p>
      </div>
      <base-switch formControlName="ratingsLocationOnly"></base-switch>
    </div>
  </div>
</form>

<ng-template #updateCompanySettingModal>
  <base-customer-company-setting-activation-modal
    [confirmationText]="changeSettingConfirmationText"
    [settingDescription]="changeSettingDescription"
  ></base-customer-company-setting-activation-modal>
</ng-template>
